<template>
  <div class="container-flex fill-flex-full">
    <div v-if="reloading" id="circle2"></div>
    <global-error v-if="globalError" />
    <div v-else class="container-right container-flex fill-flex-full">
      <div class="container-flex fill-flex-full">
        <div class="main container-flex fill-flex-full" v-if="client">
          <div class="container-fluid container-flex fill-flex-full bg-white">
            <div class="container-wide container-flex fill-flex-full">
              <div class="spacer-75"></div>
              <div class="row mx-4 mt-5">
                <div class="col-md-4 d-flex">
                  <div class="col-md-2">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="show_inactive"
                      v-model="showInactive"
                    />
                    <label for="show_inactive" class="ml-2"></label>
                  </div>
                  <div class="col-md-6">
                    <label for="show_inactive" class="ml-2"
                      >Показывать отключенные</label
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-2 px-4">
                <div class="col-12">
                  <div class="row">
                    <div class="col-1"><p class="grey">Логин</p></div>
                    <div class="col-1"><p class="grey">Статус</p></div>
                    <div class="col-1"><p class="grey">Начало работы</p></div>
                    <div class="col-1">
                      <p class="grey">Завершение работы</p>
                    </div>
                    <div class="col-2">
                      <p class="grey text-center">Услуга</p>
                    </div>
                    <div class="col-2"><p class="grey">IP-адрес</p></div>
                    <div class="col-2"><p class="grey">Тариф</p></div>
                    <div class="col-2">
                      <p class="grey">Адрес подключения</p>
                    </div>
                  </div>

                  <div v-for="client in clients" :key="client.clientId">
                    <div
                      class="row border-t-full"
                      v-if="
                        clients.length > 1 && (!client.inactive || showInactive)
                      "
                    >
                      <div class="col-1 d-flex align-items-center">
                        <div :class="client.inactive ? 'red' : ''">
                          <p>{{ client.clientName }}</p>
                          <div>{{ client.clientId }}</div>
                        </div>

                        <div class="ml-1">
                          <a
                            @click="client.showServices = !client.showServices"
                            class="blue"
                            v-if="client.logins"
                            ><i
                              :class="
                                client.showServices
                                  ? 'fas fa-chevron-down'
                                  : 'fas fa-chevron-right'
                              "
                            ></i
                          ></a>
                        </div>
                      </div>
                    </div>

                    <div
                      v-show="client.showServices"
                      v-for="login in client.logins"
                      :key="login"
                    >
                      <template v-if="login.services.length > 1">
                        <div class="row border-t-full">
                          <div class="col-md-1 d-flex align-items-center">
                            <p>{{ login.services[0].login }}</p>
                            <div class="ml-2">
                              <a
                                @click="login.show = !login.show"
                                class="blue"
                                v-if="login.services"
                                ><i
                                  :class="
                                    login.show
                                      ? 'fas fa-chevron-down'
                                      : 'fas fa-chevron-right'
                                  "
                                ></i
                              ></a>
                            </div>
                          </div>
                        </div>
                        <template v-if="login.show">
                          <div
                            v-for="service in login.services"
                            :key="service.serviceId"
                          >
                            <div
                              v-if="
                                login.services[0].active !== 'F' || showInactive
                              "
                              class="row border-t-full"
                            >
                              <div class="col-1">
                                <p>{{ service.login }}</p>
                              </div>
                              <div class="col-1">
                                <div
                                  v-if="service.active"
                                  class="service-status-icon yellow"
                                  :class="{
                                    'bg-green': service.active === 'Y',
                                    'bg-red':
                                      service.active === 'F' ||
                                      service.active === 'A',
                                    'bg-blue:': service.active === 'N',
                                    'bg-yellow': service.active === 'O',
                                  }"
                                  :title="service.activeName"
                                ></div>
                              </div>
                              <div class="col-1">
                                <p>
                                  {{
                                    service.sdate
                                      ? formatDate(service.sdate)
                                      : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-1">
                                <p>
                                  {{
                                    service.edate
                                      ? formatDate(service.edate)
                                      : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-2">
                                <p>
                                  {{ service.serviceType
                                  }}<span
                                    class="small"
                                    v-if="
                                      service.hostingSize || service.emailSize
                                    "
                                    >{{
                                      ` (${
                                        service.hostingSize ?? service.emailSize
                                      }мб)`
                                    }}</span
                                  >
                                </p>
                              </div>
                              <div class="col-1">
                                <template v-if="service.ips">
                                  <div v-for="ip in service.ips" :key="ip">
                                    {{ ip.ip }}
                                  </div>
                                </template>
                              </div>
                              <div class="col-1">
                                <p v-if="service.abonPayment">
                                  {{ service.abonPayment }}&nbsp;₽{{
                                    service.annual ? " (в год)" : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-2">
                                <p>
                                  {{
                                    service.address ??
                                    service.hosting ??
                                    service.email
                                  }}
                                </p>
                              </div>
                            </div>
                            <div
                              class="row border-t-full"
                              v-for="(addService, index) in service.additional"
                              :key="index"
                            >
                              <div class="col-1">
                                <p>{{ addService.login }}</p>
                              </div>
                              <div class="col-1">
                                <div
                                  v-if="addService.active"
                                  class="service-status-icon"
                                  :class="{
                                    'bg-green': addService.active === 'Y',
                                    'bg-red':
                                      addService.active === 'F' ||
                                      addService.active === 'A',
                                    'bg-blue:': addService.active === 'N',
                                    'bg-yellow': addService.active === 'O',
                                  }"
                                  :title="addService.activeName"
                                ></div>
                              </div>
                              <div class="col-1">
                                <p>
                                  {{
                                    addService.sdate
                                      ? formatDate(addService.sdate)
                                      : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-1">
                                <p>
                                  {{
                                    addService.edate
                                      ? formatDate(addService.edate)
                                      : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-2">
                                <p>
                                  {{ addService.serviceType
                                  }}<span
                                    class="small"
                                    v-if="
                                      addService.hostingSize ||
                                      addService.emailSize
                                    "
                                    >{{
                                      ` (${
                                        addService.hostingSize ??
                                        addService.emailSize
                                      }мб)`
                                    }}</span
                                  >
                                </p>
                              </div>
                              <div class="col-2"></div>
                              <div class="col-2">
                                <p v-if="addService.abonPayment">
                                  {{ addService.abonPayment }}&nbsp;₽{{
                                    addService.annual ? " (в год)" : ""
                                  }}
                                </p>
                              </div>
                              <div class="col-2">
                                <p>
                                  {{
                                    addService.address ??
                                    addService.hosting ??
                                    addService.email
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <div
                          v-if="
                            login.services[0].active !== 'F' || showInactive
                          "
                          class="row border-t-full"
                        >
                          <div class="col-1">
                            <p>{{ login.services[0].login }}</p>
                          </div>
                          <div class="col-1">
                            <div
                              v-if="login.services[0].active"
                              class="service-status-icon"
                              :class="{
                                'bg-green': login.services[0].active === 'Y',
                                'bg-red':
                                  login.services[0].active === 'F' ||
                                  login.services[0].active === 'A',
                                'bg-blue:': login.services[0].active === 'N',
                                'bg-yellow': login.services[0].active === 'O',
                              }"
                              :title="login.services[0].activeName"
                            ></div>
                          </div>
                          <div class="col-1">
                            <p>
                              {{
                                login.services[0].sdate
                                  ? formatDate(login.services[0].sdate)
                                  : ""
                              }}
                            </p>
                          </div>
                          <div class="col-1">
                            <p>
                              {{
                                login.services[0].edate
                                  ? formatDate(login.services[0].edate)
                                  : ""
                              }}
                            </p>
                          </div>
                          <div class="col-2">
                            <p>
                              {{ login.services[0].serviceType
                              }}<span
                                class="small"
                                v-if="
                                  login.services[0].hostingSize ||
                                  login.services[0].emailSize
                                "
                                >{{
                                  ` (${
                                    login.services[0].hostingSize ??
                                    login.services[0].emailSize
                                  }мб)`
                                }}</span
                              >
                            </p>
                          </div>
                          <div class="col-2">
                            <template v-if="login.services[0].ips">
                              <div
                                v-for="ip in login.services[0].ips"
                                :key="ip"
                              >
                                {{ ip.ip.slice(0, -3) }}
                              </div>
                            </template>
                          </div>
                          <div class="col-2">
                            <div v-if="login.services[0].abonPayment">
                              {{ login.services[0].abonPayment }}&nbsp;₽{{
                                login.services[0].annual ? " (в год)" : ""
                              }}
                            </div>
                          </div>
                          <div class="col-2">
                            <p>
                              {{
                                login.services[0].address ??
                                login.services[0].hosting ??
                                login.services[0].email
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="row border-t-full"
                          v-for="(addService, index) in login.services[0]
                            .additional"
                          :key="index"
                        >
                          <div class="col-1">
                            <p>{{ addService.login }}</p>
                          </div>
                          <div class="col-1">
                            <div
                              v-if="addService.active"
                              class="service-status-icon yellow"
                              :class="{
                                'bg-green': addService.active === 'Y',
                                'bg-red':
                                  addService.active === 'F' ||
                                  addService.active === 'A',
                                'bg-blue:': addService.active === 'N',
                                'bg-yellow': addService.active === 'O',
                              }"
                              :title="addService.activeName"
                            ></div>
                          </div>
                          <div class="col-1">
                            <p>
                              {{
                                addService.sdate
                                  ? formatDate(addService.sdate)
                                  : ""
                              }}
                            </p>
                          </div>
                          <div class="col-1">
                            <p>
                              {{
                                addService.edate
                                  ? formatDate(addService.edate)
                                  : ""
                              }}
                            </p>
                          </div>
                          <div class="col-2">
                            <p>
                              {{ addService.serviceType
                              }}<span
                                class="small"
                                v-if="
                                  addService.hostingSize || addService.emailSize
                                "
                                >{{
                                  ` (${
                                    addService.hostingSize ??
                                    addService.emailSize
                                  }мб)`
                                }}</span
                              >
                            </p>
                          </div>
                          <div class="col-2"></div>
                          <div class="col-2">
                            <p v-if="addService.abonPayment">
                              {{ addService.abonPayment }}&nbsp;₽{{
                                addService.annual ? " (в год)" : ""
                              }}
                            </p>
                          </div>
                          <div class="col-2">
                            <p>
                              {{
                                addService.address ??
                                addService.hosting ??
                                addService.email
                              }}
                            </p>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="fill-flex-full"></div>
              <div class="spacer-75"></div>

              <!-- <div class="row px-dynamic">
                <router-link
                  exact-active-class="active"
                  class="mr-4 h3-rem"
                  :to="'/services/' + index"
                  v-for="index in parseInt(pages)"
                  :key="index"
                  >{{ index }}</router-link
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { CLIENTS } from "@/api/clients";
import { mapActions, mapGetters } from "vuex";
import GlobalError from "../components/GlobalError.vue";

export default {
  components: {
    GlobalError,
  },
  data() {
    return {
      reloading: false,
      showServices: false,
      modClient: [],
      showInactive: false,
    };
  },

  mounted() {
    if (this.clients.length < 2) {
      this.clients[0].showServices = true;
    }
  },

  created() {
    if (this.client === null) {
      this.fetchClient();
    }

    // Предварительная обработка данных: группировка услуг по логинам, добавления свойства для "показывать/не показывать", удаление услуг с расторгнутым договором.

    this.modClient = this.client.clientGroup.map(function (current) {
      let client = Object.assign({}, current);
      client.showServices = false;
      return client;
    });

    for (let i = 0; i < this.modClient.length; i++) {
      this.modClient[i].logins = {};
      for (let j = 0; j < this.modClient[i].services.length; j++) {
        if (
          !(this.modClient[i].services[j].login in this.modClient[i].logins)
        ) {
          this.modClient[i].logins[this.modClient[i].services[j].login] = {
            services: [],
            show: false,
          };
        }
        this.modClient[i].logins[
          this.modClient[i].services[j].login
        ].services.push(this.modClient[i].services[j]);
      }
      // for (let login in this.modClient[i].logins) {
      //   if (
      //     this.modClient[i].logins[login].services.filter(
      //       (service) => service.active === "F"
      //     ).length == this.modClient[i].logins[login].services.length
      //   ) {
      //     delete this.modClient[i].logins[login];
      //   }
      // }
      if (
        this.modClient[i].services.filter((service) => service.active === "F")
          .length == this.modClient[i].services.length
      ) {
        //delete this.modClient[i].logins;
        this.modClient[i].inactive = true;
      }
    }
  },

  computed: {
    ...mapGetters(["globalError", "client"]),

    /*client() {
      return CLIENTS[3];
    },*/

    pages() {
      const elems = 10;
      return this.client.clientGroup.length / elems + 1;
    },

    clients() {
      // const elems = 10;
      // const start = elems * (this.$route.params.page - 1);
      // const end = start + elems;
      //this.client.clientGroup.forEach(client => client.showServices = false);

      // if (
      //   this.$route.params.page > 0 &&
      //   this.$route.params.page <= this.pages
      // ) {
      //   return this.modClient.slice(start, end);
      // }
      return this.modClient;
    },
  },

  methods: {
    ...mapActions(["fetchClient"]),

    formatDate(date) {
      return date.split(" ")[0].split("-").reverse().join(".");
    },
  },
};
</script>
